
<nav class="navbar navbar-expand-md navbar-dark header__vimpel" [ngClass]="sidebarCollapsed ? 'header__vimpel--collapsed' : ''">

    <button class="navbar-toggler" type="button"
            (click)="navbarCollapsed = !navbarCollapsed"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div *ngIf="currentClient?.kid > -1"
        [routerLink]="['/clients/' + currentClient?.kid]"
        [ngClass]="sidebarCollapsed ? 'menuitems__name--collapsed' : 'menuitems__name--normal'"
        class="clickable">
        <span class="menuitems__name--client-name">{{currentClient?.glkundenr}}</span>
        <span class="menuitems__name--client-name">{{currentClient?.navn1}}</span>
        <span class="menuitems__name--client-name">{{currentClient?.navn2}}</span>
    </div>

    <div class="collapse navbar-collapse" [ngbCollapse]="navbarCollapsed" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto header__menuitems">
            <ng-container *ngFor="let item of menu">
                <li *ngIf="item.items" ngbDropdown display="dynamic" placement="bottom-right" class="nav-item dropdown">
                    <a ngbDropdownToggle
                        class="nav-link"
                        placement="bottom"
                        ngbTooltip="{{item.name}}"
                        #t="ngbTooltip"
                        (click)="t.close()"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        ><i class="header__item--normal {{item.icon}}" aria-hidden="true">
                            <span *ngIf="item.badgeCount > 0" class="badge badge-danger">{{item.badgeCount}}</span>
                        </i>
                        <span class="header__menutext">{{item.name}}</span>
                    </a>
                    <div ngbDropdownMenu>
                        <ng-container *ngFor="let itemx of item.items">
                            <a *ngIf="itemx.baseurl && !itemx.target && currentUser.indexCard.lev >= itemx.lev && (!itemx.legacy || hasLegacy)"
                                class="dropdown-item"
                                (click)="openLegacy(itemx.url); navbarCollapsed=true"
                                >{{itemx.name}}
                            </a>
                            <a *ngIf="itemx.url && itemx.target === '_window' && currentUser.indexCard.lev >= itemx.lev && (!itemx.legacy || hasLegacy)"
                                class="dropdown-item"
                                (click)="openWindow(itemx.url);navbarCollapsed=true;"
                                >{{itemx.name}}
                            </a>
                            <a *ngIf="itemx.url && itemx.target === '_blank' && currentUser.indexCard.lev >= itemx.lev && (!itemx.legacy || hasLegacy)"
                                class="dropdown-item"
                                (click)="openLinkInTab(itemx.url);navbarCollapsed=true;"
                                >{{itemx.name}}
                            </a>
                            <a *ngIf="(itemx.method && itemx.method != 'switchOffice' && itemx.method != 'impersonate' && itemx.method != 'clientActionsSettings')
                                        || (itemx.method === 'switchOffice' && currentUser.offices.length > 1)
                                        || (itemx.method === 'impersonate' && isSupporter)
                                        || (itemx.method === 'clientActionsSettings' && (isFaglig || isSupporter))"
                                class="dropdown-item"
                                (click)="onMethodCall(itemx.method);navbarCollapsed=true;"
                                >{{itemx.name}}
                            </a>
                            <a *ngIf="itemx.headervar === 'username'"
                                class="dropdown-header"
                                >{{currentUser.fullname}}
                            </a>
                            <a *ngIf="itemx.headervar === 'header'"
                            class="dropdown-header"
                            >{{itemx.name}}
                            </a>
                        </ng-container>
                    </div>
                </li>
                <li *ngIf="!item.items" class="nav-item">
                    <a *ngIf="!item.method && hasLegacy"
                        class="nav-link"
                        placement="bottom"
                        ngbTooltip="{{item.name}}"
                        #t="ngbTooltip"
                        (click)="t.close();openLegacy(item.url);navbarCollapsed=true"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        ><i class="header__item--normal {{item.icon}}" aria-hidden="true"><span *ngIf="item.badgeCount > 0" class="badge badge-danger">{{item.badgeCount}}</span></i>
                        <span class="header__menutext">{{item.name}}</span>
                    </a>
                    <a *ngIf="item.method"
                        class="nav-link"
                        placement="bottom"
                        ngbTooltip="{{item.name}}"
                        #t="ngbTooltip"
                        (click)="t.close();onMethodCall(item.method);navbarCollapsed=true;"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        ><i class="header__item--normal {{item.icon}}" aria-hidden="true"><span *ngIf="item.badgeCount > 0" class="badge badge-danger">{{item.badgeCount}}</span></i>
                        <span class="header__menutext">{{item.name}}</span>
                    </a>
                </li>
            </ng-container>
        </ul>
    </div>

</nav>
